<template>
    <div class="p-3">
        <h3>Ganti Nomor RM</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">No. RM/Nama/NIK/No Kartu BPJS</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>
            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>

        <div class="modal" tabindex="-1" ref="modal_ganti_rm">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ganti Nomor RM</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label for="medrec" class="col-sm-4 col-form-label">No. Rekam Medis</label>
                            <div class="col-sm-8">
                                <input type="text" name="medrec" id="medrec" v-model="data_pasien.Medrec" @keyup="disable_simpan = true" class="form-control">
                            </div>
                        </div>

                        <div v-if="check_pasien_error_message != ''" class="alert alert-warning mt-3" role="alert">
                            {{ check_pasien_error_message }}
                        </div>

                        <div v-if="check_pasien_error_message != ''">
                            <div class="row">
                                <div class="col-sm-4">Nomor RM</div>
                                <div class="col-sm-8">: {{ data_check_pasien.Medrec }}</div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">Nama</div>
                                <div class="col-sm-8">: {{ data_check_pasien.Firstname }}</div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">NIK</div>
                                <div class="col-sm-8">: {{ data_check_pasien.NoIden }}</div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">Nomor Kartu BPJS</div>
                                <div class="col-sm-8">: {{ data_check_pasien.AskesNo }}</div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">Tanggal lahir</div>
                                <div class="col-sm-8">: {{ data_check_pasien.Bod }}</div>
                            </div>
                        </div>

                        <div v-if="check_pasien_success_message != ''" class="alert alert-success mt-3" role="alert">
                            {{ check_pasien_success_message }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
                        <button type="button" class="btn btn-warning" @click="cekRM">Cek No RM</button>
                        <button type="button" class="btn btn-primary" @click="goChangeRM" :disabled="disable_simpan">Simpan</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default {
    data() {
        return {
            master_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            },
            data_pasien: [],
            disable_simpan: true,
            check_pasien_error_message: '',
            check_pasien_success_message: '',
            data_check_pasien: [],
            pasien_past_medrec: '',
            pasien_new_medrec: '',
            modal: null
        }
    },
    created() {
        //
    },
    mounted() {
        this.getAllPasien()
    },
    methods: {
        getAllPasien() {
            const uri = `/api/ganti-rm/get-all-pasien?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}&page=${this.filter.page}`

            const element = document.getElementById('table-pasien')

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',
                columns: [
                    {title: 'No Rekam Medis', field: 'Medrec'},
                    {title: 'Nama', field: 'Firstname'},
                    {title: 'Tanggal Lahir', field: 'Bod'},
                    {title: 'NIK', field: 'NoIden'},
                    {title: 'No Kartu BPJS', field: 'AskesNo'},
                    {title: 'Tanggal Daftar', field: 'tgl_daftar'},
                    {title: 'Action', formatter: function () {
                        return '<button class="btn btn-sm btn-primary">Ganti Nomor RM</button>'
                    }, cellClick: this.gantiNomorRM},
                ]
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            return response.master_pasiens
        },
        gantiNomorRM(e, cell) {
            this.data_pasien = cell.getRow().getData()
            this.pasien_past_medrec = { ...this.data_pasien }

            const modal_ganti_rm = this.$refs.modal_ganti_rm
            this.modal = new Modal(modal_ganti_rm)
            this.modal.show()
        },
        resetFilters() {
            this.filter = {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }

            this.getAllPasien()
        },
        cekRM() {
            const new_medrec = this.data_pasien.Medrec
            const uri = `/api/ganti-rm/get-detail-pasien?Medrec=${new_medrec}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.data_check_pasien = response.data.pasien
                    console.log('data_check_pasien:', this.data_check_pasien)
                    this.disable_simpan = false

                    if (this.data_check_pasien) {
                        this.check_pasien_error_message = `Data pasien dengan nomor RM ${new_medrec} sudah ada dan akan tergantikan! Yakin akan dilanjutkan? Jika data sudah terupdate, tidak bisa dikembalikan lagi.`
                        this.check_pasien_success_message = ''
                    } else {
                        this.check_pasien_error_message = ''
                        this.check_pasien_success_message = `Tidak ada data pasien dengan nomor RM ${new_medrec}. Perubahan nomor RM bisa dilanjutkan.`
                    }
                }
            })
        },
        goChangeRM() {
            console.log('new_data:', this.data_pasien)
            const uri = '/api/ganti-rm/ganti-nomor-rm'
            this.pasien_new_medrec = { ...this.data_pasien }

            this.axios.post(uri, {
                past_medrec: this.pasien_past_medrec.Medrec,
                new_medrec: this.pasien_new_medrec.Medrec
            }).then(response => {
                if (response.data.status == 'success') {
                    this.modal.hide()
                    
                    this.getAllPasien()
                } else {
                    this.check_pasien_error_message = response.data.message
                    this.check_pasien_success_message = ''
                }
            })
        }
    }
}
</script>